/**
 * Пасхалки: точки на карте, которые отвечают не то, что написано на чертеже.
 *
 * Почему текст всё равно называет настоящую зону. Карта публичная и показывает
 * градостроительный документ: карточка, которая молча объявляет зону
 * садоводства курятником, читается не как шутка, а как ошибка в данных.
 * Поэтому в подсказке и карточке шутка идёт первой строкой, а настоящее
 * назначение участка — следом, и источник честно помечен пасхалкой.
 */

export interface EasterEggZone {
  /** Долгота и широта центра участка. */
  lng: number;
  lat: number;
  /** Радиус срабатывания в метрах: пасхалку надо найти, а не споткнуться о неё. */
  radiusMetres: number;
  title: string;
  description: string;
  /** Проигрывать ли звук по клику. */
  sound?: "rooster";
}

export const EASTER_EGGS: EasterEggZone[] = [
  {
    lng: 20.48133,
    lat: 54.711777,
    radiusMetres: 30,
    title: "Курятник",
    description:
      "Режим использования: зерно, червяки, подъём в 04:30. "
      + "По генеральному плану здесь зона садоводства и огородничества.",
    sound: "rooster",
  },
];

/** Метров в одном градусе широты. Для долготы умножается на cos(широты). */
const METRES_PER_DEGREE = 111_320;

/**
 * Пасхалка под точкой или null.
 *
 * Расстояние считается по плоскости, а не по сфере: радиус срабатывания —
 * десятки метров, и на таком масштабе разница между плоской и сферической
 * формулой меньше сантиметра.
 */
export function eggAtPoint(lngLat: { lng: number; lat: number }): EasterEggZone | null {
  for (const egg of EASTER_EGGS) {
    const dy = (lngLat.lat - egg.lat) * METRES_PER_DEGREE;
    const dx =
      (lngLat.lng - egg.lng) * METRES_PER_DEGREE * Math.cos((egg.lat * Math.PI) / 180);
    if (Math.hypot(dx, dy) <= egg.radiusMetres) return egg;
  }
  return null;
}
